<template>
  <div class="welcome page">
    <div class="content">
        <h2>Success!</h2>
        <p>
            Welcome to the cutting edge&hellip;you'll be getting the first look at new features and beta versions.
        </p>
        <v-btn class="md-primary md-raised" to="/">
            Back to homepage
        </v-btn>
    </div>
  </div>
</template>

<script>


  export default {
    name: 'welcome'
  }
</script>


<style scoped lang="scss">



</style>


